import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { Button } from 'components/misc'
import { apiOrganizations } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { logError } from 'redux/modules/app'
import { selectMap } from 'redux/selectors/misc'
import { Select } from 'components/fields'

@apiOrganizations({ disablePaging: true })
@form({
  form: 'move-award-unit'
})
@connect(
  ({ api }) => ({
    organizations: api.organizations,
    oasList: selectMap(api.organizations.listOAs),
    soasList: selectMap(api.organizations.listSOAs)
  }),
  {
    logError
  }
)
class AwardUnitMove extends Component {
  static propTypes = {
    oasList: PropTypes.array.isRequired,
    soasList: PropTypes.array.isRequired,
    organizations: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    moveOrganization: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object,
    logError: PropTypes.func.isRequired,
    getOrganizations: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    values: {}
  }

  componentDidMount = () => {
    const { data } = this.props

    this.props
      .getOrganizations({
        filterCase: 'NaoOAs',
        parentNaoId: get(data, 'parentNAO.id'),
        disableLimit: true,
        resetFilter: true
      })
      .catch(err => this.props.logError(err))
  }

  handleOaSelected = (obj = {}) => {
    this.props
      .getOrganizations({
        filterCase: 'OaSOAs',
        filterById: obj.value,
        disableLimit: true,
        resetFilter: true
      })
      .catch(err => this.props.logError(err))
  }

  handleSubmit = fields =>
    this.props.moveOrganization(this.props.data, fields, {
      updateDetail: true
    })

  render() {
    const {
      organizations,
      oasList,
      soasList,
      handleSubmit,
      values,
      submitting
    } = this.props

    let disabled = !values.oaId

    if (soasList.length > 0) {
      disabled = !values.oaId || !values.soaId
    }

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className="row">
          <div className="col-xs-12">
            <h2 className="text--center">
              <FormattedMessage
                id="organisation.would_you_like_to_move_award_unit"
                defaultMessage="Would you like to move Award Unit?"
              />
            </h2>
          </div>
          <div className="col-xs-12">
            <div className="base-margin--bottom">
              <Select
                name="oaId"
                label="Operating authority"
                options={oasList}
                loading={organizations.loading && oasList.length === 0}
                onSelectChange={this.handleOaSelected}
              />
            </div>
          </div>
          {values.oaId &&
            soasList.length > 0 &&
            <div className="col-xs-12">
              <Select
                name="soaId"
                label="Sub operating authority"
                loading={organizations.loading && !submitting}
                options={soasList}
              />
            </div>}
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              onClick={this.props.onClose}
              secondary
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              disabled={disabled}
              intlKey="button.move"
              isLoading={submitting}
            >
              Move
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default AwardUnitMove
